import React from 'react';
import { FlaskConical } from 'lucide-react';
import { Card, CardContent, CardHeader } from './ui/Card';
import { Textarea } from './ui/Textarea';
import { SectionHeader } from './ui/SectionHeader';
import { MedicalFormData } from '../hooks/useFormState';
interface LabInvestigationsProps {
  data: MedicalFormData;
  onChange: (field: keyof MedicalFormData, value: any) => void;
}
export function LabInvestigations({
  data,
  onChange
}: LabInvestigationsProps) {
  return <Card data-id="element-137">
      <CardHeader data-id="element-138">
        <SectionHeader title="Laboratory Investigations" icon={<FlaskConical className="w-5 h-5" data-id="element-140" />} data-id="element-139" />
      </CardHeader>
      <CardContent data-id="element-141">
        <Textarea value={data.labInvestigations} onChange={e => onChange('labInvestigations', e.target.value)} placeholder="Blood tests, X-Ray, MRI results..." className="min-h-[100px]" data-id="element-142" />
      </CardContent>
    </Card>;
}